<div class="custom-file-upload-container">
  <ng-container [formGroup]="group">
    <div
      class="dropzone"
      [class.active]="isDragging"
      [class.collapsed]="!model.showDropzone"
      [class.disabled]="model.disabled"
      (click)="openFileDialog()"
      (drop)="onDrop($event)"
      (dragover)="onDragover($event)"
      (dragleave)="onDragleave($event)"
      data-test="gsm-file-upload_dropzone"
    >
      <button
        type="button"
        mat-stroked-button
        class="add-button"
        [color]="isValid ? 'primary' : 'warn'"
        [disabled]="model.disabled"
        data-test="gsm-file-upload_add-btn"
      >
        <div class="add-button-inner">
          <mat-icon>add</mat-icon>
          {{ model.labelTooltip + (model.required ? ' *' : '') }}
        </div>
      </button>
      <span class="mat-small hint-text">Dateien hierher ziehen oder klicken</span>
    </div>
    <input #fileUpload hidden type="file" [multiple]="model.multiple" [accept]="model.accept?.join(',')"
           (change)="onFilesAdded()"/>
    <div class="file-upload-description mat-typography">
      <ul data-test="gsm-file-upload_file-list">
        <li *ngFor="let file of model.value; index as i" class="file-wrapper">
          <gsm-upload-progress
            *gsmLet="progressMap.get(file)?.progress$ | async as update"
            [condensed]="true"
            [fileName]="file.originalFileName"
            [hidden]="!update?.progress"
            [bytesLoaded]="update?.progress?.bytesLoaded"
            [bytesTotal]="update?.progress?.bytesTotal"
            (cancelEvent)="progressMap.get(file).cancelUpload()"
          ></gsm-upload-progress>

          <div *ngIf="file.fileId || file.error" class="flex-row">
            <mat-icon *ngIf="file.error" title="Fehler beim Hochladen" color="warn">error</mat-icon>
            <span class="file-name">{{ file.originalFileName }}</span>
            <span class="end">
              <button *ngIf="!file.error" mat-icon-button (click)="openFile(file)" data-test="gsm-file-upload_view-btn">
                <mat-icon>visibility</mat-icon>
              </button>
              <button *ngIf="file.error" mat-icon-button (click)="retryUpload(file)"
                      data-test="gsm-file-upload_retry-btn">
                <mat-icon>refresh</mat-icon>
              </button>
              <button *ngIf="!model.disabled" mat-icon-button (click)="removeFile(file)"
                      data-test="gsm-file-upload_delete-btn">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
